import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import api from './api';

class PushNotificationService {
  constructor() {
    this.initialized = false;
  }

  async initialize() {
    if (this.initialized) return;
    
    // Only initialize on native platforms
    if (!Capacitor.isNativePlatform()) {
      console.log('Push notifications only available on native platforms');
      return;
    }

    try {
      // Request permission
      const permResult = await PushNotifications.requestPermissions();
      
      if (permResult.receive === 'granted') {
        // Register with APNS/FCM
        await PushNotifications.register();
        
        // Setup listeners
        this.setupListeners();
        this.initialized = true;
        console.log('Push notifications initialized');
      } else {
        console.log('Push notification permission denied');
      }
    } catch (error) {
      console.error('Error initializing push notifications:', error);
    }
  }

  setupListeners() {
    // On successful registration, get the token
    PushNotifications.addListener('registration', async (token) => {
      console.log('Push registration success, token:', token.value);
      
      // Send token to backend
      try {
        await api.post('/notifications/register-device', {
          token: token.value,
          platform: Capacitor.getPlatform()
        });
        console.log('Device token registered with backend');
      } catch (error) {
        console.error('Failed to register device token:', error);
      }
    });

    // Registration error
    PushNotifications.addListener('registrationError', (error) => {
      console.error('Push registration error:', error);
    });

    // Notification received while app is in foreground
    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('Push notification received:', notification);
      
      // Show local notification or update UI
      if (window.showNotificationToast) {
        window.showNotificationToast({
          title: notification.title,
          body: notification.body
        });
      }
    });

    // Notification action performed (user tapped on notification)
    PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
      console.log('Push notification action performed:', notification);
      
      // Navigate based on notification data
      const data = notification.notification.data;
      if (data?.route) {
        window.location.href = data.route;
      }
    });
  }

  async getDeliveredNotifications() {
    if (!Capacitor.isNativePlatform()) return [];
    
    try {
      const result = await PushNotifications.getDeliveredNotifications();
      return result.notifications;
    } catch (error) {
      console.error('Error getting delivered notifications:', error);
      return [];
    }
  }

  async removeAllDeliveredNotifications() {
    if (!Capacitor.isNativePlatform()) return;
    
    try {
      await PushNotifications.removeAllDeliveredNotifications();
    } catch (error) {
      console.error('Error removing notifications:', error);
    }
  }
}

export const pushNotificationService = new PushNotificationService();
export default pushNotificationService;
